import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the userHeaderBox state domain
 */

const selectUserHeaderBoxDomain = (state) =>
  state.get("userHeaderBox", initialState)

export const makeSelectIsLoading = () =>
  createSelector(selectUserHeaderBoxDomain, (state) => state.get("isLoading"))

/**
 * Other specific selectors
 */

export const makeSelectUsername = () =>
  createSelector(selectUserHeaderBoxDomain, (state) => state.get("username"))

/**
 * Default selector used by UserHeaderBox
 */

const makeSelectUserHeaderBox = () =>
  createSelector(selectUserHeaderBoxDomain, (substate) => substate.toJS())

export default makeSelectUserHeaderBox
export { selectUserHeaderBoxDomain }
